import React, {Fragment} from 'react';
import {NavLink} from 'react-router-dom'
import {connect} from "react-redux";


class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      1: false
    }
  }

  toggleMenu(idMenu) {
    this.setState({
      [idMenu]: !this.state[idMenu]
    })
  }

  render() {
    const {affiliatesList} = this.props;

    let showFullSideBar = false;

    if(affiliatesList){
      affiliatesList.forEach(affiliate => {
        if(affiliate.affiliate.status === "enabled"){
          showFullSideBar = true;
        }
      });
    }

    return (
      <nav className="sidebarContainer">
        <ul className="list-unstyled sidebar">

          {showFullSideBar ? (
            <Fragment>
              <li className={`sidebar-item`}>
                <NavLink activeClassName="active" exact to="/home"><span className="icon-own-view_quilt sidebarIcon"/>Dashboard</NavLink>
              </li>
              <li className={`sidebar-item`}>
                <NavLink activeClassName="active" to="/home/reports"><span className="icon-own-timeline sidebarIcon"/>Reports</NavLink>
              </li>
              <li className={`sidebar-item`}>
                <NavLink activeClassName="active" to="/home/returns"><span className="icon-own-format_list_bulleted sidebarIcon"/>Returns</NavLink>
              </li>
              <li className={`sidebar-item`}>
                <NavLink activeClassName="active" to="/home/payouts"><span className="icon-own-euro_symbol sidebarIcon"/>Payouts</NavLink>
              </li>
              <li className={`sidebar-item`}>
                <NavLink activeClassName="active" to="/home/config"><span className="icon-own-build sidebarIcon"/>Config</NavLink>
              </li>
            </Fragment> ) : (<Fragment></Fragment>)}

            <li className={`sidebar-item`}>
              <NavLink activeClassName="active" to="/home/clients"><span className="icon-own-icon-num-collective sidebarIcon"/>Clients</NavLink>
            </li>
        </ul>
      </nav>
    );
  }
};

const mapStateToProps = (state) => {

  const {affiliates} = state;

  return {
    affiliatesList: affiliates.affiliatesList
  };
};



export default connect(mapStateToProps, null, null, {
  pure: false
})(Sidebar);